const commonTypography = {
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",

  h1: {
    fontWeight: 700,
    fontSize: "3rem",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  h2: {
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1.3,
    letterSpacing: "-0.01em",
  },
  h3: {
    fontWeight: 600,
    fontSize: "1.875rem",
    lineHeight: 1.35,
  },
  h4: {
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: 1.4,
  },
  h5: {
    fontWeight: 500,
    fontSize: "1.25rem",
    lineHeight: 1.45,
  },
  h6: {
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: 1.5,
  },

  body1: {
    fontSize: "1rem",
    lineHeight: 1.6,
    fontWeight: 400,
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: 1.5,
    fontWeight: 400,
  },
  bodyBold: {
    fontSize: "1rem",
    lineHeight: 1.6,
    fontWeight: 700, // bold weight
  },
  button: {
    fontSize: "0.875rem",
    fontWeight: 600,
    letterSpacing: "0.5px",
    // textTransform: "uppercase",  
  },

  caption: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.3,
    color: "#888888",
  },
};

const theme = {
  palette: {
    mode: "light",

    // Brand primary color
    // Use for: buttons, navbar highlights, form submit
    primary: {
      main: "#F4C542",
      contrastText: "#ffffff",
    },

    // Accent color
    // Use for: highlights, badges, secondary buttons
    secondary: {
      main: "#FFF2A2",
      contrastText: "#AB992E",
    },

    // Deep accent color
    // Use for: hover states, headings, icon backgrounds
    tertiary: {
      main: "#AB992E",
      contrastText: "#ffffff",
    },

    // Main background color
    // Use for: body background, hero section
    background: {
      default: "#FFF8D0",
      paper: "#ffffff", // Use for: cards, modals, input containers
    },

    // Typography color
    // primary: headings, readable text on light bg
    // secondary: helper text, subtitles
    text: {
      primary: "#AB992E",
      secondary: "#6E550C",
      tertiary: "#ffffff",
      disabled:'#ccc'
    },

    // Feedback colors
    success: {
      main: "#74E5A3", // Fresh green that complements your yellow palette
      contrastText: "#ffffff",
    },

    warning: {
      main: "#FBD768", // Golden-orange warning tone (deeper than primary)
      contrastText: "#000000",
    },

    error: {
      main: "#FFA27B", // Warm red for errors
      contrastText: "#ffffff",
    },

    info: {
      main: "#1976d2", // Optional: keep default blue for info messages
      contrastText: "#ffffff",
      light:"#e3f2fd"
    },
    dark:{
      main: "#000000",
      contrastText: "#ffffff",
    },

    // Utility: Determines best text color (black/white) based on bg
    getContrastText: (background) => {
      const color =
        background.charAt(0) === "#" ? background.substring(1) : background;
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },
  },

  // Correct placement of typography
  typography: commonTypography,

  // Shape properties: use for consistent border radius (rounded corners)
  shape: {
    borderRadius: "0.5rem", // use as style={{ borderRadius: theme.shape.borderRadius }}
    borderRadius1: "1.5rem", // use as style={{ borderRadius: theme.shape.borderRadius }}
    borderRadius2: "2.5rem", // use as style={{ borderRadius: theme.shape.borderRadius }}
    borderRadius3: "3.5rem", // use as style={{ borderRadius: theme.shape.borderRadius }}

  },

  // Spacing function: multiply factor by 0.25rem for consistent margins/paddings
  spacing: (factor) => `${0.25 * factor}rem`,
  // Example usage: style={{ padding: theme.spacing(4) }}  // gives 1rem padding

  // Transitions: easing and duration presets for smooth animations
  transitions: {
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)", // default ease-in-out curve
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  // Usage example:
  // style={{
  //   transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`
  // }}

  // zIndex levels: consistent layering order for UI elements
  zIndex: {
    appBar: 1100, // Navbar, headers
    drawer: 1200, // Side drawers or offcanvas menus
    modal: 1300, // Modal dialogs
    snackbar: 1400, // Toast notifications
    tooltip: 1500, // Tooltips
  },
  // Usage example: style={{ zIndex: theme.zIndex.modal }}

  // Breakpoints for responsive design
  breakpoints: {
    values: {
      xs: 0, // Extra small devices (phones)
      sm: 600, // Small devices (tablets)
      md: 900, // Medium devices (small laptops)
      lg: 1200, // Large devices (desktops)
      xl: 1536, // Extra large devices (large screens)
    },
  },
  // Usage example:
  // @media (min-width: ${theme.breakpoints.values.md}px) { ... }

  // Shadows for elevation & depth effects
  shadows: [
    "none",
    "0px 1px 3px rgba(0,0,0,0.12), 0px 1px 2px rgba(0,0,0,0.24)", // subtle shadow for cards, buttons
    "0px 3px 6px rgba(0,0,0,0.16), 0px 3px 6px rgba(0,0,0,0.23)",
    "0 8px 24px rgba(0,0,0,0.18)",
    // Add more shadows if needed
  ],
  // Usage example:
  // style={{ boxShadow: theme.shadows[1] }}
};

export default theme;
